// Centralized data storage and retrieval
const STORAGE_KEYS = {
  BLOG_POSTS: 'arithmify_blog_posts',
  PORTFOLIO_PROJECTS: 'arithmify_portfolio_projects',
  SERVICES: 'arithmify_services',
  TESTIMONIALS: 'arithmify_testimonials',
};

export const storage = {
  // Blog Posts
  getBlogPosts: (): any[] => {
    if (typeof window === 'undefined') return [];
    try {
      const data = localStorage.getItem(STORAGE_KEYS.BLOG_POSTS);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  },
  setBlogPosts: (posts: any[]): void => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(STORAGE_KEYS.BLOG_POSTS, JSON.stringify(posts));
  },

  // Portfolio Projects
  getPortfolioProjects: (): any[] => {
    if (typeof window === 'undefined') return [];
    try {
      const data = localStorage.getItem(STORAGE_KEYS.PORTFOLIO_PROJECTS);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  },
  setPortfolioProjects: (projects: any[]): void => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(STORAGE_KEYS.PORTFOLIO_PROJECTS, JSON.stringify(projects));
  },

  // Services
  getServices: (): any[] => {
    if (typeof window === 'undefined') return [];
    try {
      const data = localStorage.getItem(STORAGE_KEYS.SERVICES);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  },
  setServices: (services: any[]): void => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(STORAGE_KEYS.SERVICES, JSON.stringify(services));
  },

  // Testimonials
  getTestimonials: (): any[] => {
    if (typeof window === 'undefined') return [];
    try {
      const data = localStorage.getItem(STORAGE_KEYS.TESTIMONIALS);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  },
  setTestimonials: (testimonials: any[]): void => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(STORAGE_KEYS.TESTIMONIALS, JSON.stringify(testimonials));
  },

  // Clear all data
  clearAll: (): void => {
    if (typeof window === 'undefined') return;
    Object.values(STORAGE_KEYS).forEach((key) => localStorage.removeItem(key));
  },
};
